import React, { useState,  forwardRef, useContext, useEffect } from 'react';
import axios from 'axios';
// import { AuthorizeContext } from "../../RootContext";
import {Form, FormGroup, ControlLabel, FormControl, Modal} from 'react-bootstrap';
import { Button} from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
// import logo from './../../img/lento_logo.jpg';
// import styles from './../../styles';
import { useHistory } from 'react-router-dom';

import { api_url } from "./authorize";
// import moment from 'moment';
import { createTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MaterialTable from 'material-table';
import tableIcons from "./components/MaterialTableIcons"
import { AuthorizeContext }  from './RootContext';

  const useStyles = makeStyles({
    root: {
      background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
      border: 0,
      borderRadius: 3,
      boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      color: 'white',
      height: 48,
      padding: '0 30px',
    },
    title: {
      fontSize: '2em'
    }
  });

  const theme = createTheme({
    typography: { h6: {fontSize: '1.4em'}},
  });

  const tableStyles = makeStyles({
    root: {justifyContent: 'space-evenly'},
    spacing: {justifyContent: 'space-evenly'}
  });

  

const EnterBill = () => {
  const { token, role, setAuthBody, setAuthenticated, authBody } = useContext(AuthorizeContext);
  const tableClass = tableStyles()
  const [rowSelection, setRowSelection] = useState([]);
  const classes = useStyles();
  const [starting, setStarting] = useState(0)
  // const [loading, setLoading] = useState(true)
  // const [profile, setProfile] = useState(authBody || {role: "visitor"})
  const [tableData,setTableData]=useState([])
  const [allData,setAlldata]=useState([])
  const [unpaidData,setUnpaiddata]=useState([])
  const history = useHistory();

  const goBack = () => {
    history.goBack();
  };

  // API CALLS
  // Call to populate table data

  const formatDisplayDate = (value) => {
    if (!value) return "";

    const cleanValue = String(value).trim();

    //Handle date

    if(cleanValue.includes("/")) {
      const parts = cleanValue.split("/");
      if (parts.length === 3) {
        const month = String(parseInt(parts[0], 10)).padStart(2, "0");
        const day = String(parseInt(parts[1], 10)).padStart(2, "0");
        const year = parts[2];

        return `${month}/${day}/${year}`;
      }
    }

    if(cleanValue.includes("-")) {
      const parts = cleanValue.split("-");
      if (parts.length === 3 && parts[0].length === 4) {
        const year = parts[0];
        const month = String(parseInt(parts[1], 10)).padStart(2, "0");
        const day = String(parseInt(parts[2], 10)).padStart(2, "0");
        
        return `${month}/${day}/${year}`;
      }
    }

    const parsedDate = new Date(cleanValue);
    if (isNaN(parsedDate.getTime())) return cleanValue;

    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
    const day = String(parsedDate.getDate()).padStart(2, "0");

    return `${month}/${day}/${year}`;
  };

  const normalizeJobRows = (rows, shippedDateByCaseId = {}) => {
    if (!Array.isArray(rows)) return [];

    return rows.map((row) => {
      const correctShippedDate = 
        shippedDateByCaseId[row.case_id] ||
        row.shipped_date ||
        row.Shipped_Date ||
        row.shipping_date ||
        row.Shipping_Date ||
        row.package_date ||
        row.Package_Date ||
        row.Date_Issued ||
        row.invoice_date ||
        row.Invoice_Date ||
        row.date_shipped ||
        row.Date_Shipped ||
        row.date_added;

      return {
        ...row,
        shipped_date_display: formatDisplayDate(correctShippedDate),
      };
    });
  };








   useEffect(() => {
    const fetchData = async () => {
      try {
        const jobsRes = await axios({
          url: `https://${api_url}/api/jobsprocessed`,
          method: 'get',
          headers: {
            'x-access-token': token
          }
        });

        if (jobsRes.data.message) {
          alert(jobsRes.data.message);
          return;
        }
        else if (jobsRes.data.validation) {
          alert(jobsRes.data.validation.replace("_", " "));
          return;
        }
        else if (jobsRes.data.notLoggedIn) {
          setAuthenticated(false);
          setAuthBody({ role: 'visitor' });
          alert("You have been logged out due to inactivity. Please log in again.");
          return;
        }

        const packingRes = await axios({
          url: `https://${api_url}/api/packing_invoice`,
          method: 'get',
          headers: {
            'x-access-token': token
          }
        });

        const shippedDateByCaseId = {};

        if (Array.isArray(packingRes.data)) {
          packingRes.data.forEach((packingInvoice) => {
            const shippedDate = packingInvoice.Date_Issued;

            if (Array.isArray(packingInvoice.Cases)) {
              packingInvoice.Cases.forEach((caseId) => {
                shippedDateByCaseId[caseId] = shippedDate;
              });
            }
          });
        }

        const normalizedUnpaidJobs = normalizeJobRows(
          jobsRes.data.unpaid_jobs,
          shippedDateByCaseId
        );

        const normalizedAllJobs = normalizeJobRows(
          jobsRes.data.all_jobs,
          shippedDateByCaseId
        );

        const savedBillView = sessionStorage.getItem("enterBillView") || "unpaid";

        setStarting(jobsRes.data.starting);
        setAlldata(normalizedAllJobs);
        setUnpaiddata(normalizedUnpaidJobs);

        if (savedBillView === "all") {
          setTableData(normalizedAllJobs);
        } else {
          setTableData(normalizedUnpaidJobs);
        }

        console.log("jobsprocessed:", jobsRes.data);
        console.log("packing_invoice:", packingRes.data);
        console.log("shippedDateByCaseId:", shippedDateByCaseId);
      }
      catch (error) {
        console.error("Error loading Enter Bill data:", error);
        alert("Error loading Enter Bill data.");
      }
    };

    fetchData();
  }, []);

        




            console.log(starting)

  // const hasRole = (profile, roles) =>{
  //   return roles.includes(role)
  // }


  const editTheRow = (ROWdata) => {
    // API call to edit a row in the database
    const jd = {
      "job_data": ROWdata
    }
     axios({
      url:`https://${api_url}/api/jobsprocessed?mongo_id=${ROWdata._id}`,
      method: 'put',
      data: jd,
      headers: {
         'x-access-token' : token
      }
    }).then(
      res =>{
        if(res.data.message){
          alert(res.data.message)
        }
        else if(res.data.validation){
          alert(res.data.validation.replace("_", " "))
        }
        else if(res.data.notLoggedIn){
          setAuthenticated(false)
          setAuthBody({role: 'visitor'})
          alert("You have been logged out due to inactivity. Please log in again.")
        }
         else{
          console.log(res.data)
          // setTableData(res.data)
          window.location.reload()
        }
      }
    )
  }
  const approve_payment = (joblist) => {
    // API call to edit a row in the database
    const lj = {
      "list_of_jobs": joblist
    }
     axios({
      url:`https://${api_url}/api/jobsprocessed?approve_payment=true`,
      method: 'put',
      data: lj,
      headers: {
         'x-access-token' : token
      }
    }).then(
      res =>{
        if(res.data.message){
          alert(res.data.message)
        }
        else if(res.data.validation){
          alert(res.data.validation.replace("_", " "))
        }
        else if(res.data.notLoggedIn){
          setAuthenticated(false)
          setAuthBody({role: 'visitor'})
          alert("You have been logged out due to inactivity. Please log in again.")
        }
         else{
          console.log(res.data)
          setTableData(res.data)
          window.location.reload()
        }
      }
    )
  }

  const populate_jobsprocessed = () => {
    
     axios({
      url:`https://${api_url}/api/jobsprocessed`,
      method: 'post',
      data: [],
      headers: {
         'x-access-token' : token
      }
    }).then(
      res =>{
        if(res.data.message){
          alert(res.data.message)
        }
        else if(res.data.validation){
          alert(res.data.validation.replace("_", " "))
        }
        else if(res.data.notLoggedIn){
          setAuthenticated(false)
          setAuthBody({role: 'visitor'})
          alert("You have been logged out due to inactivity. Please log in again.")
        }
         else{
          console.log(res.data)
          alert(res.data.message)
         
        }
      }
    )
  }

  const [state, setState] = useState({
    columns: [
    { title: 'Bill ID #', field:'billing_id', editable: 'never'},
    { title: 'Processor Name', field:'processor_name', cellStyle:{ fontSize: '1em'}, editable: 'never'},
    { title: 'Acct No', field:'Acct_No', cellStyle:{ fontSize: '1em'}, editable: 'never'},
    { title: 'Case ID #', field:'case_id', cellStyle:{ fontSize: '1em'}, editable: 'never'},
    { title: 'Shipped Date', field:'shipped_date_display', cellStyle:{ fontSize: '1em'}, editable: 'never',
      render: rowData => {
        return (
          <div>
          {rowData.shipped_date_display || ""}
          </div>
        );
      }
    },      
    { title: 'Process ID', field:'process_id', cellStyle:{ fontSize: '1em'}, editable: 'never'},
    { title: 'AMT', field:'job_amt', cellStyle:{ fontSize: '1em'},type : 'currency'},
    { title: 'PMT ID #', field:'payment_id', cellStyle:{ fontSize: '1em'}, editable: 'never'},
    { title: 'PMT Date', field:'payment_date', cellStyle:{ fontSize: '1em'}, editable: 'never'}
    ]
  });

let unique = [];

const calculate_pid = (starting) => {
    // create empty list variables
    let accts = []
    let acct_ids = [];
    // grabbing the names from selected row data
    rowSelection.forEach((row) => accts.push(row.Acct_No));
    // create a set of the name to eliminate duplicates
    const unique = [...new Set(accts)];
    // combining the unique names with a unique ID
    unique.forEach((acct1,index) => acct_ids.push([acct1, starting+index]))

    console.log(acct_ids)
    // Loop thru and check the names to assign unique ID's
    acct_ids.forEach((person, index) =>{
       rowSelection.forEach((row)=> {
            if (row.Acct_No === person[0]){
               row.payment_id = person[1]
               //change the data for the db
            } 
          })
    });

}
const unpaidbillsBtn = () => {
   sessionStorage.setItem("enterBillView", "unpaid");
   window.location.reload();
};

const allbillsBtn = () => {
  sessionStorage.setItem("enterBillView", "all");
   window.location.reload();
};
const approvePaymentBtn =() => {
    calculate_pid(starting);
    console.log(rowSelection)
    let rows = rowSelection;
    //if not selected any checkbox, Pop-up Alert message
    if (rows.length === 0) {
      alert('Please select at least one column.');
    } else {
    // Perform some action with the selected columns
      console.log('Selected columns:', rows);
    }
    //brig current date information and put "theDate"
    const theDate = new Date().toLocaleDateString();
    //put date in the selected rows
    rows.forEach((row) => row.payment_date = theDate);
    approve_payment(rows)
    setRowSelection([]);
    rows = []

  };

  return(
    
      <div className="EnterBill">
      <h1 align="center">ENTER BILL</h1>
      {/*When click the button go to 'approvePaymentBtn' function*/}
      <button onClick={approvePaymentBtn}>
      Approve Payment
      </button> <br />     
      <button onClick={populate_jobsprocessed}>
      Add to Enter Bill
      </button> <br />     
      
      <button onClick={allbillsBtn} style={{ margin: '.3em 0' }}>
      All Bills
      </button>
      <button onClick={unpaidbillsBtn}>
      Unpaid Bills
      </button>            
      <button onClick={goBack}>
      Back
      </button>
      <ThemeProvider theme={theme}>
      <MaterialTable 
      title="Enter Bill"
      //tableIcons from Components folder with definition
      icons={tableIcons}
      //Using above columns function
      columns={state.columns} 
      //tableData use inside of Enterbill Function but switch to real DB
      data={tableData}
      enableHiding={false}
      //update Only AMT
      editable={{
          onRowUpdate:(newRow)=>new Promise((resolve,reject)=>{           
            editTheRow(newRow)
            setTimeout(()=>resolve(),500)

        }),
      }}  
      enableRowSelection
      onSelectionChange={setRowSelection}
      options={{
        sorting:true,
        search:true,
        searchFieldAlignment:"right",
        searchAutoFocus:true,
        searchFieldVariant:"outlined",
        filtering:false,
        paging:true,
        pageSizeOptions:[10,20,30,40,50],
        pageSize:5,
        paginationType:"stepped",
        showFirstLastPageButtons:false,
        paginationPosition:"bottom",
        exportButton:{
           csv: true,
        },
        exportAllData:true,
        exportFileName:"TableData",
        addRowPosition:"first",
        actionsColumnIndex:-1,
        selection:true,
        showSelectAllCheckbox:true,
        showTextRowsSelected:true,
        grouping:false,
           // selectionProps: (rowData) => ({
           //   disabled: rowData.payment_id !== '',
             // color: 'primary' ,
        //   // checked: rowData.payment_id === ''
         // }),
        // isselection:(rowData) => rowData.payment_id === '',
        columnsButton:true,
        headerStyle:{background:"lightgray",fontStyle:"italic", fontSize: 15},
        // rowStyle:(data,index)=>index%2==0?{background:"#f5f5f5"}:null,

        }}      
       />
     </ThemeProvider>

     </div>
    );
}
export default EnterBill